module.exports = __webpack_public_path__ + "static/free-trial-2903dd6612f4ea42eceec7bf7de29eb5.svg";